import { useTranslation } from "../translations/LanguageContext";

// `message` can still be passed explicitly (e.g. Compare.jsx uses
// t("loading.compareMessage")) — this component no longer hardcodes
// its own default so both call sites stay in the translation file.
export function LoadingOverlay({ message }) {
    const { t } = useTranslation();

    return (
        <div className="overlay">
            <div className="overlay-card">
                <div className="loader">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <p className="overlay-message">{message ?? t("loading.defaultMessage")}</p>
                <p className="overlay-sub">{t("loading.sub")}</p>
            </div>
        </div>
    );
}
